import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useChatsData } from "@/data/use-chats-data";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";

type DeleteChatDialogProps = {
  chatUuid: string | null;
  onOpenChange: (open: boolean) => void;
};

export const DeleteChatDialog = ({
  chatUuid,
  onOpenChange,
}: DeleteChatDialogProps) => {
  const groupSlug = useGroupSlug();
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { chats, deleteChat } = useChatsData(groupUuid, kitUuid);
  const navigate = useNavigate();

  const handleDeletion = async () => {
    if (!chatUuid) return;
    await deleteChat(chatUuid);
    toast.success("Chat deleted.");
    navigate({
      to: "/w/$groupSlug/k/$kitUuid/chat",
      params: { groupSlug, kitUuid: kitUuid! },
    });
  };

  const chat = chats.find((c) => c.uuid === chatUuid);

  if (!chat) {
    return null;
  }

  return (
    <AlertDialog open={!!chatUuid} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>Delete Chat: {chat.name}?</AlertDialogHeader>
        <AlertDialogDescription>
          Do you really want to delete this chat? This action cannot be undone.
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button size="sm" variant="destructive" onClick={handleDeletion}>
            Delete Chat
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
